
export default function CompanyHighlights() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Why Choose Golden Twin Towers
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Leading K-Beauty innovation with proven global expertise
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="text-center group hover:transform hover:scale-105 transition-all duration-300">
            <div className="w-20 h-20 bg-gradient-to-br from-[#C8A654] to-[#B8964A] rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg group-hover:shadow-xl">
              <i className="ri-global-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Global Reach</h3>
            <p className="text-gray-600 leading-relaxed">
              Comprehensive market coverage across UK, EU & MENA regions with established distribution networks
            </p>
          </div>
          
          <div className="text-center group hover:transform hover:scale-105 transition-all duration-300">
            <div className="w-20 h-20 bg-gradient-to-br from-[#C8A654] to-[#B8964A] rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg group-hover:shadow-xl">
              <i className="ri-award-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Premium Quality</h3>
            <p className="text-gray-600 leading-relaxed">
              CGMP & ISO certified manufacturing facilities ensuring the highest quality standards and compliance
            </p>
          </div>
          
          <div className="text-center group hover:transform hover:scale-105 transition-all duration-300">
            <div className="w-20 h-20 bg-gradient-to-br from-[#C8A654] to-[#B8964A] rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg group-hover:shadow-xl">
              <i className="ri-team-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Trusted Partnerships</h3>
            <p className="text-gray-600 leading-relaxed">
              Exclusive partnerships with leading Korean beauty brands including Celina Co., Ltd. and Minicell
            </p>
          </div>
          
          <div className="text-center group hover:transform hover:scale-105 transition-all duration-300">
            <div className="w-20 h-20 bg-gradient-to-br from-[#C8A654] to-[#B8964A] rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg group-hover:shadow-xl">
              <i className="ri-rocket-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Innovation Hub</h3>
            <p className="text-gray-600 leading-relaxed">
              Advanced R&D solutions and cutting-edge product development through our manufacturing partners
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
